var _a, _b;
import { __assign } from "tslib";
import { reduxKey } from './constants';
import { handleActions } from 'redux-actions';
import { setIsWriterDeviationFeatured, setIsWriterDeviationMature, saveWriterDeviation, saveWriterDeviationSuccess, saveWriterDeviationFailure, resetWriterPopup, publishWriterDeviation, setIsRedirecting, initialize, } from './actions';
var defaultState = {
    isSubmitting: false,
    isRedirecting: false,
    deviationId: null,
    error: null,
    isFeatured: false,
    isMature: false,
};
var actionHandlers = handleActions((_a = {},
    _a[initialize.toString()] = function (state, action) { return (__assign(__assign({}, state), { isFeatured: action.payload.isFeatured, isMature: action.payload.isMature })); },
    _a[setIsWriterDeviationFeatured.toString()] = function (state, action) { return (__assign(__assign({}, state), { isFeatured: action.payload.isFeatured })); },
    _a[setIsWriterDeviationMature.toString()] = function (state, action) { return (__assign(__assign({}, state), { isMature: action.payload.isMature })); },
    _a[saveWriterDeviation.toString()] = function (state) { return (__assign(__assign({}, state), { isSubmitting: true, error: null })); },
    _a[publishWriterDeviation.toString()] = function (state) { return (__assign(__assign({}, state), { isSubmitting: true, error: null })); },
    _a[saveWriterDeviationSuccess.toString()] = function (state, action) { return (__assign(__assign({}, state), { isSubmitting: false, deviationId: action.payload.deviationId, error: null })); },
    _a[saveWriterDeviationFailure.toString()] = function (state, action) { return (__assign(__assign({}, state), { isSubmitting: false, error: action.payload.error })); },
    _a[setIsRedirecting.toString()] = function (state, action) { return (__assign(__assign({}, state), { isRedirecting: action.payload.isRedirecting })); },
    _a[resetWriterPopup.toString()] = function () { return defaultState; },
    _a), defaultState);
var reducers = (_b = {},
    _b[reduxKey] = function (state, action) {
        return actionHandlers(state, action) || state;
    },
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map